import * as moment from 'moment';
import { Moment } from 'moment';

export interface IEmployerJobExperience {
  _id?: string;
  position?: string;
  company_name?: string;
  country?: string;
  city?: string;
  date_start?: Moment;
  date_end?: Moment;
  image?: string;
}

export class EmployerJobExperience implements IEmployerJobExperience {
  _id?: string;
  position?: string;
  company_name?: string;
  country?: string;
  city?: string;
  date_start?: Moment;
  date_end?: Moment;
  image?: string;

  constructor( experience: IEmployerJobExperience = {} ) {
    this._id = experience._id;
    this.position = experience.position;
    this.company_name = experience.company_name;
    this.country = experience.country || '';
    this.city = experience.city || '';
    this.date_start = experience.date_start ? moment(experience.date_start) : null;
    this.date_end = experience.date_end ? moment(experience.date_end) : null;
    this.image = experience.image === 'no_image.png' ? '/assets/no_image.png' : experience.image;
  }
}



// WEBPACK FOOTER //
// ./app/core/entities/employer-job-experience.ts